import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './Footer.css';
import logoMain from '../assets/logo_main2.png';
import logoMainReverse from '../assets/logo_main2_reserve.webp';

function Footer() {
  const { t } = useTranslation();
  const [isDarkMode, setIsDarkMode] = useState(true);

  useEffect(() => {
    // Initial check
    const checkTheme = () => {
      const storedTheme = localStorage.getItem('theme');
      if (storedTheme === 'light') {
        setIsDarkMode(false);
      } else {
        setIsDarkMode(true);
      }
    };

    checkTheme();

    // Listen to storage changes (cross-tab) or manual dispatch if implemented
    window.addEventListener('storage', checkTheme);

    // MutationObserver to watch body class for immediate switching within same tab
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          const isLight = document.body.classList.contains('light-mode');
          setIsDarkMode(!isLight);
        }
      });
    });

    observer.observe(document.body, { attributes: true });

    return () => {
      window.removeEventListener('storage', checkTheme);
      observer.disconnect();
    };
  }, []);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-brand">
          <img
            src={isDarkMode ? logoMainReverse : logoMain}
            alt="Vorpoint Logo"
            className="footer-logo-icon"
          />
          <p className="footer-slogan">{t('footer.slogan')}</p>
        </div>
        <nav className="footer-nav">
          <ul>
            <li><Link to="/">{t('header.home')}</Link></li>
            <li><Link to="/ueber-uns-neu">{t('header.about')}</Link></li>
            <li><Link to="/leistungen">{t('header.services')}</Link></li>
            <li><Link to="/kontakt">{t('header.contact')}</Link></li>
          </ul>
        </nav>
        <div className="footer-contact">
          <h3>{t('footer.contact_title')}</h3>
          <p>{t('footer.contact_name')}</p>
          <p>{t('footer.contact_email')}</p>
          <p>{t('footer.contact_phone')}</p>
        </div>
        <div className="footer-legal">
          <ul>
            <li><Link to="/impressum">{t('footer.legal_imprint')}</Link></li>
            <li><Link to="/datenschutz">{t('footer.legal_privacy')}</Link></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2025 Vorpoint. {t('footer.copyright')}</p>
      </div>
    </footer>
  );
}

export default Footer;
